<template>
  <b-row>
    <b-col>
      <div class="flex-container">
        <circle9 class="spinning-icon" />
        <div class="mt-2">Please wait...</div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { Circle9 } from 'vue-loading-spinner';


export default {
  components: {
    Circle9,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/Spinner.vue